// client/src/hooks/useRecibosHistorico.js
import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const BASE_ROUTE = 'recibos';
const QUERY_KEY = 'recibosHistorico';

// Histórico de recibos emitidos (menu Documentos > Recibos). Cada registro
// já vem com o HTML final gerado no momento da emissão
// (GET /recibos/gerar/:agendamentoId/:templateId), então esta tela apenas
// lista/exibe — nunca reprocessa o template.
export const useRecibosHistorico = (params = {}, options = {}) => {
    const { setAlert } = useAlert();
    return useQuery({
        queryKey: [QUERY_KEY, params],
        queryFn: async () => {
            try {
                const { data } = await apiClient.get(`/${BASE_ROUTE}`, { params });
                return data.data || [];
            } catch (error) {
                const errorMsg = error.response?.data?.error || 'Erro ao carregar histórico de recibos.';
                setAlert(errorMsg, 'danger');
                throw error;
            }
        },
        staleTime: 1000 * 30,
        ...options,
    });
};

export const useReciboHistoricoById = (id, options = {}) => {
    const { setAlert } = useAlert();
    return useQuery({
        queryKey: [QUERY_KEY, id],
        queryFn: async () => {
            try {
                const { data } = await apiClient.get(`/${BASE_ROUTE}/${id}`);
                return data.data || null;
            } catch (error) {
                const errorMsg = error.response?.data?.error || 'Erro ao carregar o recibo.';
                setAlert(errorMsg, 'danger');
                throw error;
            }
        },
        enabled: !!id,
        ...options,
    });
};
